import { gql } from 'react-apollo';
import { full } from "../../../../graphql/fragments/dailyScripture";

export const createDailyScripture = gql`
  mutation createDailyScripture($input: CreateDailyScriptureInput!) {
    createDailyScripture(input: $input) {
      dailyScripture: daily_scripture {
        ...allDailyScripturesFields
      }
    }
  }

  ${full}
`;



// WEBPACK FOOTER //
// ./src/components/pages/dailyScriptures/mutations/createDailyScripture.js